module.exports = __webpack_public_path__ + "img/eu.4c73f57c.svg";